import { forwardRef } from 'react';
import { useAuthStore } from '@/stores/auth-store';

interface WithdrawalTicketProps {
  movement: any;
  registerId?: string;
}

export const WithdrawalTicket = forwardRef<HTMLDivElement, WithdrawalTicketProps>(({ movement, registerId }, ref) => {
  const { user } = useAuthStore();
  const formatCurrency = (val: any) => `$${Number(val || 0).toFixed(2)}`;
  const formatTime = (d: string) => new Date(d).toLocaleTimeString('es-MX', {
    hour: '2-digit', minute: '2-digit'
  });
  const formatDate = (d: string) => new Date(d).toLocaleDateString('es-MX', {
    day: '2-digit', month: '2-digit', year: 'numeric'
  });

  if (!movement) return null;

  return (
    <div className="hidden print:block">
      <div ref={ref} className="print-ticket p-4 font-mono text-sm text-black bg-white" style={{ fontFamily: 'monospace' }}>
        <div className="text-center mb-4">
          <h2 className="font-bold text-lg">{user?.company?.name || 'Empresa Demo'}</h2>
          <p className="text-xs">Sucursal: {user?.branch?.name || 'Principal'}</p>
          <p className="text-xs">
            Fecha: {formatDate(movement.createdAt)}, {formatTime(movement.createdAt)}
          </p>
          <p className="text-xs">Cajero: {movement.user?.fullName || user?.fullName}</p>
        </div>

        <div className="border-t border-dashed border-black my-2"></div>
        <div className="text-center font-bold text-lg tracking-widest uppercase">
          RETIRO DE EFECTIVO
        </div>
        <div className="border-t border-dashed border-black my-2"></div>

        <div className="mb-4">
          <div className="flex justify-between font-bold mb-2">
            <span>MONTO:</span>
            <span>{formatCurrency(movement.amount)}</span>
          </div>
          <div className="mb-2">
            <span className="font-bold">CONCEPTO:</span>
            <br />
            <span>{movement.reason || 'Retiro general'}</span>
          </div>
        </div>

        <div className="border-t border-dashed border-black my-2"></div>

        <div className="mt-12 text-center">
          <p>___________________________</p>
          <p className="text-xs mt-1">Firma de quien recibe</p>
        </div>

        <div className="mt-8 text-center">
          <p>___________________________</p>
          <p className="text-xs mt-1">Firma de quien entrega</p>
        </div>

      </div>

      <style>{`
        @media print {
          @page { margin: 0; }
          body { margin: 0; }
          .print-ticket { width: 80mm !important; margin: 0 auto !important; padding: 0 !important; }
        }
      `}</style>
    </div>
  );
});
